"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const StyledListItem_1 = tslib_1.__importDefault(require("./StyledListItem"));
const useBreakpoints_1 = require("./useBreakpoints");
const FallbackAppBarButton = ({ label, onClick, disableShrinking, ListItemProps, ListItemButtonProps, ListItemTextProps, }) => {
    const { isDesktop } = (0, useBreakpoints_1.useBreakpoints)();
    return (react_1.default.createElement(StyledListItem_1.default, { ...ListItemProps },
        react_1.default.createElement(ListItemButton_1.default, { onClick, ...ListItemButtonProps }, (isDesktop || disableShrinking) && (react_1.default.createElement(ListItemText_1.default, { primary: label,
            sx: {
                color: "common.white",
            },
            primaryTypographyProps: { variant: "button" },
            ...ListItemTextProps })))));
};
exports.default = FallbackAppBarButton;
